module.exports = "pegasus_template/assets/preview-12.png";